import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import NavHeight from "../utils/nav-height";

gsap.registerPlugin(ScrollToPlugin);

export default class Ajax {
    constructor() {
        this.navHeightInstance = new NavHeight();
        this.postsContainer = document.querySelector('.js-posts-container');
        if (!this.postsContainer) return;

        this.init();
    }

    init() {
        this.initCategoryFilter();
        this.initPaginationListener();
        this.initOrderbySelect();
        this.handleInitialLoadFromUrl();
    }

    initCategoryFilter() {
        const links = document.querySelectorAll('.js-category-link');
        if (!links.length) return;

        links.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                const url = new URL(link.href, window.location.origin);
                const category = url.searchParams.get('categorie') || 'all';

                document.querySelectorAll('.categories-nav_link').forEach(li => li.classList.remove('current'));
                link.closest('li').classList.add('current');

                const orderby = this.getCurrentOrderby();

                history.pushState(null, '', `?categorie=${category}&orderby=${orderby}`);
                this.fetchPosts(category, 1, orderby);
            });
        });
    }

    initPaginationListener() {
        this.postsContainer.addEventListener('click', e => {
            const link = e.target.closest('a.pagination-link');
            if (!link) return;

            const isDisabled = link.classList.contains('disabled') || link.getAttribute('aria-disabled') === 'true';
            if (isDisabled) {
                e.preventDefault();
                return;
            }

            e.preventDefault();

            const url = new URL(link.href, window.location.origin);
            let page = url.searchParams.get('paged') || 1;

            if (!url.searchParams.has('paged')) {
                const match = url.pathname.match(/\/page\/(\d+)/);
                if (match) page = match[1];
            }

            const category = url.searchParams.get('categorie') || 'all';
            const orderby = url.searchParams.get('orderby') || 'date_DESC';

            const newUrl = `?categorie=${category}&orderby=${orderby}&paged=${page}`;
            history.pushState(null, '', newUrl);

            this.scrollToTopOfPosts();
            this.fetchPosts(category, page, orderby);
        });
    }

    initOrderbySelect() {
        const select = document.querySelector('.js-select-orderby');
        if (!select) return;

        select.addEventListener('change', () => {
            const orderby = select.value;
            const urlParams = new URLSearchParams(window.location.search);
            const category = urlParams.get('categorie') || 'all';

            const newUrl = `?categorie=${category}&orderby=${orderby}`;
            history.pushState(null, '', newUrl);

            this.scrollToTopOfPosts();
            this.fetchPosts(category, 1, orderby);
        });
    }

    scrollToTopOfPosts() {
        const block = document.querySelector('.block-posts');
        if (block) {
            const navOffset = this.navHeightInstance?.navHeightValue || 0;
            const responsiveOffset = window.innerWidth >= 1200 ? 100 : 50;
            gsap.to(window, {
                duration: 0.6,
                scrollTo: {
                    y: block,
                    offsetY: navOffset + responsiveOffset,
                },
                ease: 'power2.out'
            });
        }
    }

    fetchPosts(category = 'all', paged = 1, orderby = 'date_DESC') {
        const url = `/ajax/filter-posts-by-category/?categorie=${category}&paged=${paged}&orderby=${orderby}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) throw new Error(`Erreur ${response.status}`);
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    this.postsContainer.innerHTML = data.data.html;

                    gsap.from('.post-item', {
                        opacity: 0,
                        duration: 0.5,
                        stagger: 0.1,
                        ease: 'power2.out'
                    });
                } else {
                    console.error('Réponse invalide :', data);
                }
            })
            .catch(error => {
                console.error('Erreur AJAX :', error);
            });
    }

    handleInitialLoadFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const category = urlParams.get('categorie') || 'all';
        const orderby = urlParams.get('orderby') || 'date_DESC';
        const paged = urlParams.get('paged') || 1;

        const currentLink = document.querySelector(`.js-category-link[href*="categorie=${category}"]`);
        if (currentLink) currentLink.closest('li').classList.add('current');

        const select = document.querySelector('.js-orderby-select');
        if (select) select.value = orderby;

        this.fetchPosts(category, paged, orderby);
    }

    getCurrentOrderby() {
        const select = document.querySelector('.js-orderby-select');
        return select ? select.value : 'date_DESC';
    }
}
